import reporting from 'Utils/api/reporting';

export const report = (method, name, value, tags) =>
  reporting.post('/datadog', { method, name, value, tags });
